// Takes the served domain and stripa 'app.'
// Has a replace to make localhost work with livenviro-assemble 'vagrant'
// Replace this function locally if needed
export const getHost = () => {
  return window.location.hostname.replace('app.', '').replace('localhost', 'vagrant');
}